import client from './client'
import type { ApiResponse, AuthResponse } from '../types'
import { usePermissionsStore, type PermissionsPayload } from '../store/permissionsStore'
import { useAuthStore } from '../store/authStore'

export async function login(email: string, password: string): Promise<AuthResponse> {
  const response = await client.post<ApiResponse<AuthResponse>>('/auth/login', {
    email,
    password,
  })
  return response.data.data
}

export async function logout(): Promise<void> {
  await client.post('/auth/logout')
}

export async function getMe(): Promise<AuthResponse['user']> {
  const response = await client.get<ApiResponse<AuthResponse['user']>>('/auth/me')
  return response.data.data
}

/**
 * Načte oprávnění přihlášeného uživatele (schopnosti, superuživatel, role s úvodní stránkou)
 * a uloží je do permissionsStore (pro runtime `can()`). Volá se po přihlášení, po impersonaci
 * a při startu aplikace. Selhání je tiché — `can()` pak padá zpět na výchozí matici.
 */
export async function fetchPermissions(): Promise<void> {
  try {
    const response = await client.get<ApiResponse<PermissionsPayload>>('/auth/permissions')
    const userId = useAuthStore.getState().user?.id ?? null
    usePermissionsStore.getState().setPermissions(response.data.data, userId)
  } catch {
    // ponecháme fallback na výchozí matici
  } finally {
    usePermissionsStore.getState().markLoaded()
  }
}
